

import { DateRange } from "react-date-range";


import "./styles.css";

import "./default.css";

export const TripCalendar = ({setDateRange, dateRange, setDateIsPlaceholder}) => {
   





    return (
        <DateRange
            ranges={dateRange}

            onChange={(item) => {
              
            
                setDateRange([item.selection]);
                setDateIsPlaceholder(false);
              
               
            }}
            months={2}
            /*   direction={direction} */
            direction='horizontal'
            showDateDisplay={false}
            rangeColors={['#3b82f6']}
        />
    );
};